import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=6de0f99d&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=6de0f99d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0f99d",
  null
  
)

export default component.exports